import styled from 'styled-components';
import BaseLoadingSpinner from '../../elements/LoadingSpinner';
export var Container = styled.div.withConfig({
  displayName: "EmailConfirmationstyles__Container",
  componentId: "pantheon__sc-8jt9wj-0"
})(["margin:0 auto;max-width:900px;padding:1rem;text-align:center;"]);
export var LoadingSpinner = styled(BaseLoadingSpinner).withConfig({
  displayName: "EmailConfirmationstyles__LoadingSpinner",
  componentId: "pantheon__sc-8jt9wj-1"
})(["margin:0 auto;"]);